// extracted by mini-css-extract-plugin
module.exports = {"title":"ConfirmationModal_title__2vS2S"};